import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutPayeeForWireFundsLookup extends Layout {
    sourcePayeeForWireFunds: DataSource;
    tableCarriersForAssignment: Table;
}
